/* Reef Lagoon hero — resilient autoplay.
 * Poster always shows (rendered in markup). The video is loaded on top ONLY when safe:
 * skipped in in-app browsers, for reduced-motion users, and on data-saver connections.
 * Mobile gets 720p, desktop 1080p. Runs on initial load AND on the theme editor's
 * shopify:section:load event. Idempotent per <video>. */
(function () {
  'use strict';

  function initHero(root) {
    if (!root) return;
    var video = root.querySelector('[data-rl-hero-video]');
    if (!video || video.dataset.rlHeroInit === '1') return;
    video.dataset.rlHeroInit = '1';

    var ua = navigator.userAgent || '';
    var inApp = /(FBAN|FBAV|Instagram|Line\/|Twitter|GSA|; wv\))/i.test(ua);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;

    if (inApp || reduce || saveData) {
      if (window.console) {
        console.info('[rl-hero] poster-only path (inApp=' + inApp + ', reduce=' + !!reduce + ', saveData=' + !!saveData + ')');
      }
      return; // poster stays — the safe path
    }

    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var src = mobile ? video.getAttribute('data-src-mobile') : video.getAttribute('data-src-desktop');
    if (!src) return;

    // Muted is REQUIRED for a programmatic autoplay to be allowed. Set the property,
    // not just the attribute — the attribute alone is not reliably honoured here.
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;

    // Assigning src kicks off the load; do NOT also call load() — that can abort play().
    video.src = src;

    var attempt = video.play();
    if (attempt && typeof attempt.then === 'function') {
      attempt
        .then(function () { video.classList.add('is-ready'); })
        .catch(function (err) {
          // Stay on the poster, and log WHY so it's diagnosable in the console.
          if (window.console) {
            console.warn('[rl-hero] autoplay blocked — staying on poster:', err && err.name, err && err.message);
          }
        });
    } else {
      video.classList.add('is-ready');
    }
  }

  function initAll() {
    var heroes = document.querySelectorAll('.rl-hero');
    for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: a fresh <video> is injected when the section (re)loads — re-init it.
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (target && target.querySelector) {
      var hero = target.querySelector('.rl-hero');
      if (hero) { initHero(hero); return; }
    }
    initAll();
  });
})();
